import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
    usePagination,
    MenuItem,
    Select,
    TextField,
    InputAdornment,
    Tabs,
    Tab,
    Collapse,
    Paper,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import imgFaq from "../../../../assets/images/faq/img_faq.svg";
import background from "../../../../assets/images/faq/img_bg_faq.svg";
import cssVariables from "../../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import { ReactComponent as Add } from "../../../../assets/images/faq/icon-add.svg";
import { ReactComponent as Readmore } from "../../../../assets/images/faq/icon-readmore.svg";
import { ReactComponent as Arrow } from "../../../../assets/images/faq/icon_arrow.svg";
import faqsService from "../../../../services/faqs.service";
import * as Util from "../../../../services/global.service";


const styles = {
    path: {
        color: "#68717A",
    },
    paPlanning: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)",
        "border-radius": "10px",
        padding: "17px 22px",
        height: "100%",
    },


    paperContainer: {
        backgroundImage: `url(${background})`,
        width: "100%",
        backgroundSize: "cover",
        maxHeight: "100%",
        height: "590px",
        backgroundRepeat: "no-repeat",
        position: "relative",
    },

    arrow: {
        width: '15px',
        height: '12px',
        marginLeft: '18px',
    }

};





const useStyles = makeStyles({
    swiperStyles: {
        paddingTop: "10px !important"

    },
    iconContainer: {
        '& svg': {
            width: "45px",
            height: "45px"
        }
    },
    statusBadge: {
        maxWidth: "150px",
        borderRadius: "5px",
        padding: "5px 12px",
        margin: "0",
    },
    processBgGoals: {
        background: "#4085C9 !important",
        "&:hover": {
            backgroundColor: "#4085C9 !important",
        },
    },




    processBgCompetency: {
        background: "#958CCB !important",
    },

})

const ListFaq = () => {

    const { t } = useTranslation()


    const [mainData, setMainData] = React.useState(
        {
            books_type: [
                {

                    type: "rubric"

                },
                {

                    type: "kpi"
                },
                {

                    type: "common"
                }
            ],

            list: {
                rubric: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319e",
                        title: "การวางแผนบันทึกข้อตกลง (Planning)",
                        excerpt: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        description: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },

                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319f",
                        title: "รายการผลงาน (Workload and performance)",
                        excerpt: "ศูนย์รวมรายการผลงานที่ไม่ว่าจะเกี่ยวข้องกับการประเมินหรือเป็นผลงานที่นอกเหนือจากการประเมิน ก็สามารถสร้างบันทึกผลงานสะสมไว้ได้ โดยตลอดรอบการประเมินคุณจะสามารถเข้ามาอัพเดตผลงานได้เรื่อยๆ และยังแนบไฟล์เพื่อเป้นหลักฐานว่าผลงานนั้นเกิดขึ้นจริงได้อีกด้วย",
                        description: "ssssssssssssssssssssssssssssssssssssssssss",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },



                ],

                kpi: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319a",
                        title: "kpiiiiiiiiiiiiiiii",
                        excerpt: "aaaaaa",
                        description: "uuuuuuu",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },


                ],

                common: [
                    {
                        serial: "85b963a8-ee22-4ba3-af28-9824713c319c",
                        title: "common",
                        excerpt: "t666666",
                        description: "999999",
                        video_type: "youtube",
                        thumbnail: "https://ipop-pms.s3.ap-southeast-1.amazonaws.com/handbook/ipoppms-handbook-1.jpg",
                        video_url: "https://www.youtube.com/embed/30Y9kBijqS0"

                    },


                ]
            },

        }

    );


    const [searchFaq, setSearchFaq] = React.useState({});
    const [dataFaqs, setDataList] = React.useState({});
    const [search, setSearchValue] = React.useState("");
    const [valueTab, setValueTab] = React.useState("");
    const [isCollapse, setCollapse] = React.useState(false);
    const [isCollapseManage, setCollapseManage] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const [lengthResult, setLengthResult] = React.useState(0);
    const handleCollapse = () => {
        setCollapse(!isCollapse)
    }

    // const handleCollapseManage = () => {
    //     setCollapseManage(!isCollapseManage)
    // }

    const handleChangeWorkloadType = (_, val) => {
        setValueTab(val);
    };

    const handleCollapseManage = (data) => {
        if (data !== valueSerial) {

            setValueSerial(data)

        } else {

            setValueSerial("")

        }

    }
    useEffect(() => {
        dataSerachs();
    }, [search, valueTab]);



    useEffect(() => {

        if (dataFaqs !== undefined && dataFaqs !== null && dataFaqs !== "null") {
            getListFaq();
        }
    }, []);

    let { type } = useParams();

    // useEffect(() => {

    //     defaultType()

    // }, [dataFaqs]);

    const getListFaq = () => {
        faqsService.faqs().then(
            (response) => {
                if (response.data !== undefined && response.data !== null && response.data !== "null") {
                    setDataList(response.data)
                    setSearchFaq(response.data);
                    for (let i = 0; i < response.data.faq_type.length; i++) {
                        setValueTab(response.data.faq_type[0].type);
                    }
                }


            },
        );
    }

    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    const dataSerachs = async (event) => {
        let result = {}
        let dataSerach = JSON.parse(JSON.stringify(dataFaqs?.list))
        if (search !== "" && dataSerach !== undefined && Object.keys(dataSerach).length > 0) {
            for (let index = 0; index <= Object.keys(dataSerach).length - 1; index++) {
                let resultData = dataSerach[Object.keys(dataSerach)[index]].filter(rs => {
                    return Object.keys(rs).some(key => {

                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;


                    });
                });
                result[Object.keys(dataSerach)[index]] = resultData
            }
        } else {
            result = dataSerach;
        }
        setLengthResult(result[valueTab].length, 8);
        await setSearchFaq({ ...dataFaqs, list: result });

    };


    // handle search

    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };



    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }




    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    width: '100%'
                }}
            >

                <Box style={styles.paperContainer}>
                    <Grid container pt={2} pb={2} sx={{ paddingLeft: '20px', paddingTop: '20px' }}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t("faq.label.homePage")}</span> / <span style={styles.end} >{t("faq.label.faqPage")}</span></Typography>
                    </Grid>

                    <Grid sx={{ display: 'flex', alignItems: "flex-end", height: '100%' }}>
                        <Grid lg md xs={12} item m="30px" mt="0px" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-end' }}>
                            <Grid lg md xs={4} sx={{ maxWidth: "max-content !important" }} >
                                <img src={imgFaq} style={{ maxWidth: '470px', maxHeight: '470px' }}>

                                </img>
                            </Grid>
                            <Grid lg md xs={8} display='flex' justifyContent='center' flexDirection='column' pb="60px" >
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography fontSize={48} lineHeight="52px" fontWeight={600} color="#404349"  >
                                        {t("faq.label.faq")}
                                    </Typography>


                                </Box>
                                <Grid item display='flex' justifyContent='center' mt="30px" >
                                    <TextField
                                        id="input-with-icon-textfield"
                                        placeholder={t("news.label.search")}
                                        size="small"
                                        sx={{ background: "#fff", maxWidth: '660px', borderRadius: '5px', width: '100%' }}
                                        className="searchTextField-h48"
                                        value={search}
                                        onChange={handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Box>

                <Grid container sx={{ borderBottom: "1px solid #e4e4e4" }} mt={4}>

                    <Typography fontSize={48} lineHeight="52px" fontWeight={600} color="rgba(93, 161, 150, 1)" sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "30px", width: "100%" }}>
                        {t("faq.label.guidelines")}
                    </Typography>


                    {search !== "" ?
                        <Grid item lg md xs={12}>
                            {lengthResult > 0 ?
                                <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" sx={{ paddingLeft: "40px", paddingTop: "20px" }}>
                                     {t("faq.label.reSearch")} <span style={{ fontWeight: "500" }}>"{search}"</span>  {t("faq.label.find")} {lengthResult}  {t("faq.label.result")}
                                </Typography>
                                
                                : <Typography fontSize={18} lineHeight="19.8px" fontWeight="400px" sx={{ paddingLeft: "40px", paddingTop: "20px" }}>
                                     {t("faq.label.reSearch")} <span style={{ fontWeight: "500" }}>"{search}"</span> {t("faq.label.nofind")}
                                </Typography>
                            }
                        </Grid>
                        :
                        dataFaqs?.faq_type !== undefined && dataFaqs?.faq_type !== null && dataFaqs?.faq_type.length > 1 ?
                            <Grid item lg={11} md={11} sx={{ paddingLeft: "40px", paddingRight: "40px", paddingTop: "20px", marginBottom: "18px" }} >
                                <Tabs
                                    value={valueTab}
                                    indicatorColor="primary"
                                    onChange={handleChangeWorkloadType}
                                    aria-label="Tabs"
                                    TabIndicatorProps={{
                                        style: {
                                            height: "8px",
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            textColor: "rgba(93, 161, 150, 1)"
                                        },
                                    }}
                                >
                                    {dataFaqs?.faq_type !== undefined && dataFaqs?.faq_type !== null && dataFaqs?.faq_type.length > 0 ? dataFaqs?.faq_type.map((loRow) => (


                                        <Tab label={loRow?.type} value={loRow?.type} classes={{ root: classes.tab }} />


                                    ))

                                        : null}
                                </Tabs>
                            </Grid>

                            : <Grid>
                                
                            </Grid>
                           
                    }

                    {dataFaqs?.faq_type !== undefined && dataFaqs?.faq_type !== null && dataFaqs?.faq_type.length > 0 && valueTab !== "" ? dataFaqs?.faq_type.map((loRow, index) => (

                        <>
                            <Grid container sx={{ display: valueTab === loRow?.type ? 'block' : 'none' }} pb={5} pt="10px">
                                {searchFaq.list[loRow?.type] !== undefined && searchFaq.list[loRow?.type] !== null && searchFaq.list[loRow?.type].length > 0 ?

                                    searchFaq.list[loRow?.type].map((result, index) => (
                                        <>
                                            <Grid item lg={12} md={12} p="10px 40px">
                                                <Paper elevation={1} sx={{ background: "#FFFFFF", border: '1px solid #E4E4E4', 'border-radius': '10px', padding: "25px" }} >
                                                    <Box sx={{ display: "flex", width: "100%", alignItems: "center" }}>
                                                        <Box mr={3} id="prevent">
                                                            <div className={`clickable ${classes.expandableIcon} ${valueSerial === result?.serial ? 'active' : ''}`} onClick={e => handleCollapseManage(result?.serial)} id="prevent">
                                                                {valueSerial === result?.serial ?
                                                                    <Readmore sx={{ fontSize: "0.9rem" }} id="prevent" />
                                                                    :
                                                                    <Add sx={{ fontSize: "0.9rem" }} id="prevent" />
                                                                }

                                                            </div>
                                                        </Box>


                                                        <Typography fontSize={18} lineHeight="24.59px" fontWeight={600} color="#404349" >
                                                            {formatData(result.title, "-")}
                                                        </Typography>


                                                    </Box>

                                                    <Collapse in={valueSerial === result?.serial ? true : false}>
                                                        <Typography fontSize={18} lineHeight="35px" fontWeight={400} color="#7E7E7E" sx={{ paddingLeft: "55px" }}  dangerouslySetInnerHTML={{ __html: formatData(result.description, "-") }}>
                                                          
                                                        </Typography>
                                                    </Collapse>
                                                </Paper>
                                            </Grid>




                                        </>
                                    ))

                                    : null}
                            </Grid>


                        </>


                    ))

                        : null}

                    <Box sx={{ display: 'flex', 'align-items': 'center', 'justify-content': 'center', width: '100%', height: '100%' }}>
                        <Typography fontSize={20} lineHeight="22px" fontWeight={400} color="#848484" >
                            {t("faq.label.request")}
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', 'flex-direction': 'row', 'align-items': 'center', 'justify-content': 'center', width: '100%', paddingTop: "26px", 'padding-bottom': '70px', cursor: "pointer" }} onClick={() => navigate("/kpi/faq/question", { replace: false })}>
                        <Typography fontSize={18} lineHeight="19.8px" fontWeight={400} color="#5DA196">
                            {t("faq.label.question")}
                        </Typography>

                        <Arrow style={styles.arrow} />


                    </Box>

                </Grid>
            </Box >
        </>
    )
};
export default ListFaq;


